import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=efd65438&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efd65438",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('efd65438')) {
      api.createRecord('efd65438', component.options)
    } else {
      api.reload('efd65438', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=efd65438&scoped=true&", function () {
      api.rerender('efd65438', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-47nv6WJ24rFeb/JS/comp/Accordion.vue"
export default component.exports